<template>
    <div class="type-btn">
        <i class="el-icon-remove cursor" @click="minus"></i>
        <input type="text" v-model="num" :oninput="inputDetection(num)" readonly>
        <i class="el-icon-circle-plus cursor" @click="add"></i>
    </div>
</template>
<script>
export default {
    data (){
        return{
            num:this.defautlNum || 0,
        }
    },
    watch:{
        defautlNum(val){
            this.num = val
            
        },
    },
    props:['limitNum','type','defautlNum'],
    created(){
    },
    methods:{
        add(){
            let limit = this.limitNum?this.limitNum:9
            if(this.num>=limit)return
            this.num++
            let data = {
                type:this.type,
                num:this.num
            }
            this.$emit('getNumber',data)
        },
        minus(){
            if(this.num<=0)return
            this.num--
            let data = {
                type:this.type,
                num:this.num
            }
            this.$emit('getNumber',data)
        },
        inputDetection(val){
            let limit = this.limitNum?this.limitNum:9
            let reg = /^-?\d+$/
            let num = Number(val)
            if(reg.test(val)){
                val>=limit?this.num = limit:''
            }else{
                this.num = 0
            }
           
        }
    }
}
</script>
<style lang="less" scoped>
.type-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    i{
        width: 20px;
        height: 20px;
        color: #237dc8;
        padding: 0 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
    }
    input{
        width: 54px;
        height: 18px;
        text-align: center;
        color: #606266;
    }
}
</style>

